import { render, staticRenderFns } from "./window.vue?vue&type=template&id=0c87c6c4&"
import script from "./window.vue?vue&type=script&lang=js&"
export * from "./window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports